<script>
import {vueTopprogress} from 'vue-top-progress';
import attachmentsService from '@/services/Attachments/attachmentsService';

import AttachmentSuccess from '@/components/Notifications/Attachments/AttachmentSuccess';
import AttachmentError from '@/components/Notifications/Attachments/AttachmentError';

import pessoasService from '@/services/Pessoas/pessoasService';

import {DoubleBounce} from 'vue-loading-spinner';
import logsService from '@/services/Logs/logsService';

export default {
  data() {
    return {
      isLoading: false,
      file: {
        selectedFilename: '',
        fileName: 'Documento de Renda',
      },
    };
  },
  computed: {
    loggedUser() {
      return this.$store.getters.isLoggedIn;
    },
    currentPessoa() {
      return this.$store.getters.getPessoa;
    },
    pessoaId() {
      return this.$route.params.id;
    },
  },
  components: {
    vueTopprogress,
    DoubleBounce,
  },
  methods: {
    async addNewAttachment() {
      this.$refs.topProgress.start();
      const file = await this.$refs.uploadFile.files[0];
      this.isLoading = true;

      var email = this.currentPessoa.email.email;
      if ( this.pessoaId ) {
        let pessoa = await pessoasService.findPessoaById(this.pessoaId);
        email = pessoa.email.email;
      }
      
      try {
        const logUser = {
            user: {
                email: email
            }
        };
        const logContent = this.file.fileName;
        logsService.createNewLog(logUser, '', 'Adicionar Documento Renda', '', logContent);

        await attachmentsService.addNewDocumentAttachment(file, this.file.fileName, 'InvestorDocuments', email);

        this.$notify({
          component: AttachmentSuccess,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success',
          timeout: 3000,
        });

        this.file = {};

        this.$emit('uploadDocument', 'IncomeDocument');
        // this.$router.push('/profile');
      } catch (e) {
        console.log(e);
        this.$notify({
          component: AttachmentError,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }

      this.isLoading = false;
      this.$refs.topProgress.done();
    },
    selectedFile() {
      this.file.selectedFilename = this.$refs.uploadFile.files[0].name;
    },
  },
};
</script>

<template>
<div class="attachment-list">
  <card>
    <form @submit.prevent="addNewAttachment()">
        <h5 slot="header" class="title">
          Documento de Renda
        </h5>

        <div class="row">
          <div class="col-md-12">
            <div class="file-uploader">
              <div v-if="!isLoading">
                <div class="upload-button">
                  <i slot="title" class="tim-icons icon-cloud-upload-94"></i>
                  <label for="upload-file">Selecionar..</label>
                  <input
                    @change="selectedFile()"
                    type="file"
                    name="file"
                    ref="uploadFile"
                    id="upload-file"
                    accept="image/*, video/*, .pdf, .doc, .xlsx"
                    required
                  />
                </div>
                <h2 v-if="!file.selectedFilename">
                  Clique aqui para adicionar um Anexo
                </h2>
                <h2 v-if="file.selectedFilename">
                  {{ file.selectedFilename }}
                  <i class="fas fa-times-circle" @click="file.selectedFilename = ''"></i>
                </h2>
              </div>

              <small v-if="!isLoading">
                *Serão aceitos apenas arquivos em formato de imagens, vídeos <b>.pdf</b> <b>.doc</b> e <b>.xlsx</b>
              </small>

              <double-bounce v-if="isLoading"></double-bounce>
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-custom">Upload</button>
      </form>

    <vue-topprogress ref="topProgress"></vue-topprogress>
  </card>
</div>
</template>
